'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import Image from 'next/image';
import ErrorImage from '../../public/statics/images/illustrations/error.png';
interface ErrorPageProps {
  errorMessage: string;
  title: string;
  showBackButton?: boolean;
}
export function ErrorPage(props) {
  const $ = _c(12);
  const {
    errorMessage,
    title,
    showBackButton: t0
  } = props;
  const showBackButton = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexGrow: 1,
      alignItems: "center",
      justifyContent: "center",
      gap: "24px"
    };
    t2 = <Image alt="error" src={ErrorImage} width={546} height={533} loading="eager" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <Typography variant="h3">{title}</Typography>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== errorMessage) {
    t4 = <Typography variant="body1">{errorMessage}</Typography>;
    $[4] = errorMessage;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== showBackButton) {
    t5 = showBackButton && <Button onClick={_temp} variant="outlined">Back</Button>;
    $[6] = showBackButton;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <Stack className="mt-[-40px]" sx={t1}>{t2}{t3}{t4}{t5}</Stack>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp() {
  return history.back();
}